import { FormSetting } from '@/form-settings/form-setting';
import { ControlBase } from '@components/dynamic-form/control-base';
import { ControlType } from '@components/dynamic-form/control-type';
import { DateControl } from '@components/dynamic-form/date-control';
import { SectionDynamicForm } from '@components/dynamic-form/section-dynamic-form';
import { DropdownControl } from '@components/dynamic-form/dropdown/dropdown-control';
import { DropdownOption } from '@components/dynamic-form/dropdown/dropdown-option';
import { AutocompleteControl } from '@components/dynamic-form/auto-complete/autocomplete-control';
import { Validators } from '@angular/forms';

export class RentalReservationFormSetting extends FormSetting {
  private static isNew: boolean;
  private static brands: DropdownOption[] = [];
  private static rentalPractices: any[] = [];
  private static lockRentalPractice: boolean = false;
  private static rowsVeicolo: ControlBase[] = [];
  private static rowsCliente: ControlBase[] = [];
  private static rowsPrenotazione: ControlBase[] = [];

  // Email validation pattern
  private static emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

  public static setIsNew(isNew: boolean) {
    this.isNew = isNew;

    return this;
  }

  public static setBrands(brands: DropdownOption[]) {
    this.brands = brands;

    return this;
  }

  public static setRentalPractices(rentalPractices: any[]) {
    this.rentalPractices = rentalPractices;

    return this;
  }

  public static setLockRentalPractice(lock: boolean) {
    this.lockRentalPractice = lock;

    return this;
  }

  public static getMeta(): Array<any> {
    this.rowsVeicolo = [];
    this.rowsCliente = [];
    this.rowsPrenotazione = [];

    this.addRowId();
    this.addRowMarca();
    this.addRowRentalPractice();
    this.addRowVeicoloPrenotazioneLibera();

    this.addRowDenominazioneCliente();
    this.addRowBpCliente();
    this.addRowIndirizzoCliente();
    this.addRowCittaCliente();
    this.addRowTelefonoCliente();
    this.addRowEmailCliente();

    this.addRowDataInizio();
    this.addRowDataFine();
    this.addRowNote();

    const sectionVeicolo = {
      title: 'Dati Veicolo',
      rows: this.rowsVeicolo,
      class: 'w-full',
    } as SectionDynamicForm;

    const sectionCliente = {
      title: 'Dati Cliente',
      rows: this.rowsCliente,
      class: 'w-full',
    } as SectionDynamicForm;

    const sectionPrenotazione = {
      title: 'Dettagli Prenotazione',
      rows: this.rowsPrenotazione,
      class: 'w-full',
    } as SectionDynamicForm;

    return [
      {
        sections: [sectionPrenotazione, sectionVeicolo, sectionCliente],
      },
    ];
  }

  private static addRowId() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'id';
    inputsComponent.disabled = true;
    inputsComponent.controlType = ControlType.hidden;
    inputsComponent.label = 'ID';
    inputsComponent.class = 'hidden';
    inputsComponent.hidden = true;

    this.rowsVeicolo.push(inputsComponent);
  }

  private static addRowMarca() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'marca';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Marca';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = true;
    inputsComponent.options = this.brands;
    inputsComponent.compareFn = (o1, o2) => o1?.id === o2?.id;

    this.rowsVeicolo.push(inputsComponent);
  }

  private static addRowVeicoloPrenotazioneLibera() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'veicoloPrenotazioneLibera';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Veicolo Prenotazione Libera';
    inputsComponent.class = 'w-6/12';
    // Obbligatorio in alternativa a "Pratica Noleggio": la mutua esclusività
    // (enable/disable nel component) garantisce che ne sia richiesto solo uno.
    inputsComponent.required = true;

    this.rowsVeicolo.push(inputsComponent);
  }

  private static addRowDenominazioneCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'denominazioneCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Denominazione Cliente';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = true;

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowBpCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'bpCliente';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'BP Cliente';
    inputsComponent.class = 'w-6/12';

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowIndirizzoCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'indirizzoCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Indirizzo';
    inputsComponent.class = 'w-6/12';

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowCittaCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'cittaCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Citta';
    inputsComponent.class = 'w-6/12';

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowTelefonoCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'telefonoCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Telefono';
    inputsComponent.class = 'w-6/12';

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowEmailCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'emailCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.validators = [Validators.pattern(this.emailPattern)];
    inputsComponent.errorMessage = 'Inserire un indirizzo email valido';
    inputsComponent.label = 'Responsabile venditore indirizzo email';
    inputsComponent.label = 'Email';
    inputsComponent.class = 'w-6/12';

    this.rowsCliente.push(inputsComponent);
  }

  private static addRowDataInizio() {
    const inputsComponent = {} as DateControl;
    inputsComponent.key = 'dataInizio';
    inputsComponent.controlType = ControlType.date;
    inputsComponent.label = 'Data Inizio Prenotazione';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = true;

    this.rowsPrenotazione.push(inputsComponent);
  }

  private static addRowDataFine() {
    const inputsComponent = {} as DateControl;
    inputsComponent.key = 'dataFine';
    inputsComponent.controlType = ControlType.date;
    inputsComponent.label = 'Data Fine Prenotazione';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = true;

    this.rowsPrenotazione.push(inputsComponent);
  }

  private static addRowNote() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'note';
    inputsComponent.controlType = ControlType.textArea;
    inputsComponent.label = 'Note';
    inputsComponent.class = 'w-full';

    this.rowsPrenotazione.push(inputsComponent);
  }

  private static addRowRentalPractice() {
    const inputsComponent = {} as AutocompleteControl;
    inputsComponent.key = 'rentalPractice';
    inputsComponent.controlType = ControlType.autocompleteRentalPractice;
    inputsComponent.label = 'Pratica Noleggio';
    inputsComponent.class = 'w-6/12';
    // Obbligatorio in alternativa a "Veicolo Prenotazione Libera".
    inputsComponent.required = true;
    inputsComponent.options = this.rentalPractices;
    inputsComponent.classToUse = 'RentalReservationFormComponent';
    inputsComponent.customAction = 'onRentalPracticeSelected';
    inputsComponent.clearable = true;
    inputsComponent.clearAction = 'onRentalPracticeCleared';
    inputsComponent.disabled = this.lockRentalPractice;
    inputsComponent.compareFn = (o1, o2) => o1?.id === o2?.id;

    this.rowsVeicolo.push(inputsComponent);
  }
}
